import { serviceOperationApi } from "./api";

export async function fetchDataTaller({
  accessToken,
  user,
  countryId,
  estadoId,
  page,
  pageSize,
  search,
  startDate,
  endDate,
  fullData,
}) {
  const res = await serviceOperationApi.get("/TallerData", {
    params: {
      countryId,
      userName: user.name,
      estado: estadoId,
      offset: fullData ? 0 : page,
      limit: fullData ? 0 : pageSize,
      ...(search ? { search } : {}),
      ...(startDate ? { startDate: startDate.toISOString().slice(0, 10) } : {}),
      ...(endDate ? { endDate: endDate.toISOString().slice(0, 10) } : {}),
    },
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  const formattedData = res.data.data.map((item) => ({
    ...item,
    date_created: new Date(item.date_created),
  }));

  return {
    data: formattedData,
    count: res.data.count,
    countIngreso: res.data.countIngreso,
    countProcesado: res.data.countProcesado,
    countReparacion: res.data.countReparacion,
    countFinalizado: res.data.countFinalizado,
  };
}
